import React, { Component } from "react";
import {
  Row,
  Label,
  Col,
  Modal,
  ModalBody,
  Alert,
  Button,
  Input,
} from "reactstrap";
import axios from "../../../../axios";
import Select from "react-select";
import * as url from "../../../../utils/url";
import { isTrivvyProduct, UserRole } from "../../../../utils/constants";
import ErrorMessage from "../../../../components/Message/ErrorMessage/ErrorMessage";
import Loading from "../../../../hoc/Loading/Loading";
import UserRobot1 from "../../../../assets/user-image-plc/User_Robot_1.svg";
import "./ProfileInfo.css";
import { genderMapOptions } from "../../../../utils/constants";
import DatePicker from "react-datepicker";
import moment from "moment";
import TooltipDefinition from "../../../../components/UI/TooltipDefinition/TooltipDefinition";
import { isMobile } from "../../../../utils/deviceInfo";
import rightArrowImg from "../../../../assets/right-arrow.svg";
import If from "../../../../components/Shared/If";
import ProfilePage from "../../ProfilePage";

class ProfileInfo extends Component {
  constructor(props) {
    super(props);
    console.log(this.props);
    this.state = {
      showEditProfileInfoModal: false,
      firstName: {
        value: this.props.user.firstName || "",
        updatedValue: this.props.user.firstName || "",
        error: false,
      },
      lastName: {
        value: this.props.user.lastName || "",
        updatedValue: this.props.user.lastName || "",
        error: false,
      },
      title: {
        value: this.props.user.title || "",
        updatedValue: this.props.user.title || "",
        error: false,
      },
      dIRole: {
        value: this.props.user.dIRole || "",
        updatedValue: this.props.user.dIRole || "",
      },
      gender: {
        value:
          this.props.user.gender && this.props.user.gender.reference
            ? this.props.user.gender.reference
            : null,
        options: genderMapOptions.filter((e) => e.label !== "All"),
        updatedValue:
          this.props.user.gender && this.props.user.gender.reference
            ? this.props.user.gender.reference
            : null,
      },
      ethnicity: {
        value:
          this.props.user.ethnicity && this.props.user.ethnicity.reference
            ? this.props.user.ethnicity.reference
            : null,
        options: [],
        updatedValue:
          this.props.user.ethnicity && this.props.user.ethnicity.reference
            ? this.props.user.ethnicity.reference
            : null,
      },
      occupation: {
        value:
          this.props.user.occupation && this.props.user.occupation.reference
            ? this.props.user.occupation.reference
            : null,
        options: [],
        updatedValue:
          this.props.user.occupation && this.props.user.occupation.reference
            ? this.props.user.occupation.reference
            : null,
      },
      seniority: {
        value:
          this.props.user.seniority && this.props.user.seniority.reference
            ? this.props.user.seniority.reference
            : null,
        options: [],
        updatedValue:
          this.props.user.seniority && this.props.user.seniority.reference
            ? this.props.user.seniority.reference
            : null,
      },
      sexualOrientation: {
        value:
          this.props.user.sexualOrientation &&
          this.props.user.sexualOrientation.reference
            ? this.props.user.sexualOrientation.reference
            : null,
        options: [],
        updatedValue:
          this.props.user.sexualOrientation &&
          this.props.user.sexualOrientation.reference
            ? this.props.user.sexualOrientation.reference
            : null,
      },
      veteran: {
        value:
          this.props.user.veteran && this.props.user.veteran.reference
            ? this.props.user.veteran.reference
            : null,
        options: [],
        updatedValue:
          this.props.user.veteran && this.props.user.veteran.reference
            ? this.props.user.veteran.reference
            : null,
      },
      disability: {
        value:
          this.props.user.disability && this.props.user.disability.reference
            ? this.props.user.disability.reference
            : null,
        options: [],
        updatedValue:
          this.props.user.disability && this.props.user.disability.reference
            ? this.props.user.disability.reference
            : null,
      },
      religion: {
        value:
          this.props.user.religion && this.props.user.religion.reference
            ? this.props.user.religion.reference
            : null,
        options: [],
        updatedValue:
          this.props.user.religion && this.props.user.religion.reference
            ? this.props.user.religion.reference
            : null,
      },
      birthDate: {
        value: this.props.user.birthDate ? this.props.user.birthDate : null,
        updatedValue: this.props.user.birthDate
          ? this.props.user.birthDate
          : null,
      },
      profilePic: {
        value: this.props.user.profilePic || undefined,
        updatedValue: this.props.user.profilePic || undefined,
        error: false,
      },
    };
  }

  componentDidMount() {
    let religion = [],
      sexualOrientation = [],
      veteran = [],
      disability = [],
      ethnicity = [],
      seniority = [],
      occupation = [];
    axios.get(url.getDiversityTypes).then(({ data }) => {
      let resp = data.data;
      resp.map((e) => {
        if (e.categoryGrouping === "VETERAN") {
          veteran.push({
            value: e._id,
            label: e.name,
            definition: e.definition,
          });
        } else if (e.categoryGrouping === "SEXUAL ORIENTATION") {
          sexualOrientation.push({
            value: e._id,
            label: e.name,
            definition: e.definition,
          });
        } else if (e.categoryGrouping === "DISABILITY") {
          disability.push({
            value: e._id,
            label: e.name,
            definition: e.definition,
          });
        } else if (e.categoryGrouping === "RELIGION") {
          religion.push({
            value: e._id,
            label: e.name,
            definition: e.definition,
          });
        } else if (e.categoryGrouping === "ETHNICITY") {
          ethnicity.push({
            value: e._id,
            label: e.name,
            definition: e.definition,
          });
        } else if (e.categoryGrouping === "SENIORITY") {
          if (e.name != "All") {
            seniority.push({
              value: e._id,
              label: e.name,
              definition: e.definition,
            });
          }
        } else if (e.categoryGrouping === "OCCUPATION") {
          if (e.name != "All") {
            occupation.push({
              value: e._id,
              label: e.name,
              definition: e.definition,
            });
          }
        }
      });
      this.setState((prevState) => ({
        ethnicity: { ...prevState.ethnicity, options: ethnicity },
        religion: { ...prevState.religion, options: religion },
        veteran: { ...prevState.veteran, options: veteran },
        disability: { ...prevState.disability, options: disability },
        sexualOrientation: {
          ...prevState.sexualOrientation,
          options: sexualOrientation,
        },
        occupation: { ...prevState.occupation, options: occupation },
        seniority: { ...prevState.seniority, options: seniority },
      }));
    });
  }

  handleProfilePicUpload = (event) => {
    let profilePic = event.target.files[0];
    let profilePicExt = profilePic.name.split(".")[
      profilePic.name.split(".").length - 1
    ];
    let profilePicUrl = URL.createObjectURL(event.target.files[0]);
    if (!["png", "jpg", "jpeg"].includes(profilePicExt.toLowerCase())) {
      this.setState({
        profilePicUrl: undefined,
        profilePic: {
          value: this.props.user.profilePic,
          error: true,
          errorMessage: "Only .png and .jpg files are allowed.",
        },
      });
    } else if (profilePic.size > 1024 * 1024 * 2) {
      this.setState({
        profilePicUrl: undefined,
        profilePic: {
          value: this.props.user.profilePic,
          error: true,
          errorMessage: "Image size is more that 2MB",
        },
      });
    } else {
      this.setState({
        profilePic: {
          updatedValue: profilePic,
          value: this.props.user.profilePic,
          profilePicUrl: profilePicUrl,
          error: false,
          errorMessage: "",
        },
      });
    }
  };

  diversityCheck = (diversity) => {
    console.log(diversity);
    if (diversity && diversity.reference) {
      return diversity.reference;
    } else {
      return null;
    }
  };

  showGenderLabel = (gender) => {
    console.log(gender);
    if (gender.options) {
      let val = gender.updatedValue;
      let res = gender.options.filter((e) => {
        if (e.value === val) {
          return {
            value: e.value,
            label: e.label,
          };
        }
      });
      return res[0];
    }
  };

  grabLabel = (div) => {
    console.log(div);
    if (div && div.updatedValue) {
      let val = div.updatedValue;
      let obj = div.options.filter((e) => {
        if (e.value === val) {
          return {
            value: e.value,
            label: e.label,
          };
        }
      });
      return obj[0];
    } else {
      return null;
    }
  };

  handleEditProfileInfo = () => {
    let specialChar = /[~`!#$%\^&*+=\\[\]\\';,/{}|\\":<>\?0-9]/g;

    let {
      firstName,
      lastName,
      title,
      dIRole,
      profilePic,
      birthDate,
      gender,
      occupation,
      seniority,
      ethnicity,
      religion,
      sexualOrientation,
      disability,
      veteran,
    } = { ...this.state };
    if (
      firstName.updatedValue.trim() === "" ||
      specialChar.test(firstName.updatedValue)
    ) {
      this.setState({
        firstName: {
          updatedValue: firstName.updatedValue,
          value: firstName.value,
          error: true,
          errorMessage: "Please remove any numbers or special characters.",
        },
      });
    } else if (
      lastName.updatedValue.trim() === "" ||
      specialChar.test(lastName.updatedValue)
    ) {
      this.setState({
        lastName: {
          updatedValue: lastName.updatedValue,
          value: lastName.value,
          error: true,
          errorMessage: "Please remove any numbers or special characters.",
        },
      });
    } else if (title.updatedValue.trim() === "") {
      this.setState({
        title: {
          updatedValue: "",
          value: title.value,
          error: true,
          errorMessage: "Please enter your title.",
        },
      });
    } else {
      let formData = new FormData();
      formData.append("firstName", firstName.updatedValue);
      formData.append("lastName", lastName.updatedValue);
      formData.append("ethnicity", JSON.stringify(this.grabLabel(ethnicity)));
      formData.append("religion", JSON.stringify(this.grabLabel(religion)));
      formData.append(
        "sexualOrientation",
        JSON.stringify(this.grabLabel(sexualOrientation))
      );
      formData.append("disability", JSON.stringify(this.grabLabel(disability)));
      formData.append("seniority", JSON.stringify(this.grabLabel(seniority)));
      formData.append("occupation", JSON.stringify(this.grabLabel(occupation)));
      formData.append("veteran", JSON.stringify(this.grabLabel(veteran)));
      formData.append("gender", JSON.stringify(this.grabLabel(gender)));
      formData.append("title", title.updatedValue);
      formData.append("dIRole", dIRole.updatedValue);
      formData.append("birthDate", birthDate.updatedValue);
      formData.append("profilePic", profilePic.updatedValue);
      axios
        .put(url.editProfileInfo, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          let {
            firstName,
            lastName,
            title,
            dIRole,
            profilePic,
            gender,
            ethnicity,
            religion,
            veteran,
            sexualOrientation,
            occupation,
            seniority,
            disability,
            birthDate,
          } = response.data.data;
          this.props.profileEditSuccsess({
            firstName,
            lastName,
            title,
            dIRole,
            profilePic,
            ethnicity,
            gender,
            religion,
            veteran,
            occupation,
            seniority,
            disability,
            sexualOrientation,
            birthDate,
          });
          this.setState((prevState) => ({
            showEditProfileInfoModal: false,
            firstName: { value: firstName, updatedValue: firstName },
            lastName: { value: lastName, updatedValue: lastName },
            title: { value: title, updatedValue: title },
            dIRole: { value: dIRole, updatedValue: dIRole },
            profilePic: { value: profilePic, updatedValue: profilePic },
            gender: {
              ...prevState.gender,
              updatedValue: this.diversityCheck(gender),
              value: this.diversityCheck(gender),
            },
            ethnicity: {
              ...prevState.ethnicity,
              updatedValue: this.diversityCheck(ethnicity),
              value: this.diversityCheck(ethnicity),
            },
            religion: {
              ...prevState.religion,
              updatedValue: this.diversityCheck(religion),
              value: this.diversityCheck(religion),
            },
            veteran: {
              ...prevState.veteran,
              updatedValue: this.diversityCheck(veteran),
              value: this.diversityCheck(veteran),
            },
            disability: {
              ...prevState.disability,
              updatedValue: this.diversityCheck(disability),
              value: this.diversityCheck(disability),
            },
            sexualOrientation: {
              ...prevState.sexualOrientation,
              updatedValue: this.diversityCheck(sexualOrientation),
              value: this.diversityCheck(sexualOrientation),
            },
            occupation: {
              ...prevState.occupation,
              updatedValue: this.diversityCheck(occupation),
              value: this.diversityCheck(occupation),
            },
            seniority: {
              ...prevState.seniority,
              updatedValue: this.diversityCheck(seniority),
              value: this.diversityCheck(seniority),
            },
            birthDate: {
              ...prevState.birthDate,
              updatedValue: birthDate,
              value: birthDate,
            },
          }));
        })
        .catch((error) => {
          this.setState({
            error: true,
            errorMessage: error.response.data.errors.message,
          });
        });
    }
  };

  updateDiversity = (value, obj) => {
    if (value && value.value) {
      obj["updatedValue"] = value.value;
      this.setState({ obj });
    } else {
      obj["updatedValue"] = null;
      this.setState({ obj });
    }
  };

  handleDateChange = (date) => {
    console.log(date);
    if (date) {
      this.setState({ birthDate: { updatedValue: moment(date) } });
    } else {
      this.setState({ birthDate: { updatedValue: null } });
    }
  };

  diversityValue = (div, userDiv) => {
    // console.log(div, userDiv)
    if (div.options) {
      if (div.updatedValue && (div.updatedValue.value || div.updatedValue)) {
        let val = div.updatedValue ? div.updatedValue : div.updatedValue.value;
        let obj = div.options.filter((e) => {
          if (e.value === val) {
            return {
              value: e.value,
              label: e.label,
            };
          }
        });
        return obj[0];
      } else if (userDiv && userDiv.reference) {
        let obj = div.options.filter((e) => {
          if (e.value === userDiv.reference) {
            return { value: e.value, label: e.label };
          }
        });

        return obj[0];
      }
    } else {
      return null;
    }
  };

  showLabel = (div, userDiv) => {
    // console.log('div---', div)
    if (div.options && div.options.length > 0) {
      if (div.updatedValue) {
        let obj = div.options.filter((e) => {
          if (e.value === div.updatedValue) {
            return {
              value: e.value,
              label: e.label,
            };
          }
        });
        return obj && obj[0]?obj[0].label:null
      } else {
        return "N/A";
      }
    }
  };

  nameCheck = (e) => {
    let value = e
      .replace(/<\/?![^>]+(>|$)/g, "")
      .replace(/[\. ,:-]+/g, "")
      .replace(/^\n|\n$/g, "");
  };

  renderFieldOptions = (option) => {
    console.log(option);
    let target = `${option.value}${this.props.label}`;
    return (
      <TooltipDefinition
        target={target}
        definition={option.definition}
        name={option.label}
        type="light"
        place="left"
        delayShow={500}
      />
    );
  };

  render() {
    let {
      firstName,
      lastName,
      title,
      dIRole,
      showEditProfileInfoModal,
      profilePic,
      gender,
      occupation,
      seniority,
      religion,
      ethnicity,
      sexualOrientation,
      veteran,
      disability,
      birthDate,
    } = { ...this.state };
    let { role } = { ...this.props.user };
    let name =
      (firstName.value ? firstName.value : "") +
      (lastName.value
        ? firstName.value
          ? " " + lastName.value
          : lastName.value
        : "");
    return (
      <div className={`${isMobile && "ml-3"} userProfileDetailsContainer`}>
        {/* <If condition={!isMobile}>
        <a className="edit-profile-info-link floatRight zPos1" onClick={() => {
                  this.setState((state) => ({ showEditProfileInfoModal: !state.showEditProfileInfoModal }))}}>
                  Edit Profile Information
        </a>
        </If> */}
        <div className=" zNeg1">
          <img
            src={profilePic.value || UserRobot1}
            className="zNeg1 officemate-profile-img"
          />
        </div>
        <div>
          <div className={` ${isMobile ? "mt-2" : "mt10"}`}>
            <span className="profile-label">Name</span>

            <span className="profile-value">{name}</span>
          </div>
          <div className={` ${isMobile ? "mt-2" : "mt10"}`}>
            <span className="profile-label">Title</span>

            <span className="profile-value">{title.value}</span>
          </div>
          <div className={` ${isMobile ? "mt-2" : "mt10"}`}>
            <span className="profile-label">Occupation</span>
            <span className="profile-value">
              {occupation.updatedValue ? this.showLabel(occupation) : null}
            </span>
          </div>

          <div className={` ${isMobile ? "mt-2" : "mt10"}`}>
            <span className="profile-label">Job Category</span>
            <span className="profile-value">
              {seniority.updatedValue ? this.showLabel(seniority) : null}
            </span>
          </div>
          <div className={` ${isMobile ? "mt-2" : "mt10"}`}>
            {/* <Col className="text-right">
            <span className="profile-label">DEI Role</span>
          </Col>
          <Col  className="align-self-center">
            <span className="profile-value">{dIRole.value}</span>
          </Col> */}

            <Alert color="info">
              <span className="alert-info-text">
                <span className="alert-info-icon"></span>

                {isTrivvyProduct() ? (
                  <span>
                    Please self-identify below regarding your gender, ethnicity,
                    sexual orientation, veteran status, disability, age and
                    religion. This information is private to you, and is never
                    disclosed to other users, your employer or anyone else. It
                    is used only for purposes of understanding the demographics
                    of our users. You can edit the information at any time.
                  </span>
                ) : (
                  <span>
                    {" "}
                    Please self-identify below regarding your gender, ethnicity,
                    sexual orientation, veteran status, disability, age and
                    religion. This information is private to you, and is never
                    disclosed to other users, your employer or anyone else. It
                    is used only for purposes of improving your own experience
                    on this platform, and creating anonymously aggregated
                    benchmarks to improve diversity, inclusion and belonging in
                    your organization. You can edit the information at any time.
                  </span>
                )}
              </span>
            </Alert>

            <Col>
              <span className="profile-label">Date Of Birth</span>

              <span className="profile-value">
                {birthDate.updatedValue
                  ? moment(birthDate.updatedValue).format("MM/DD/YYYY")
                  : null}
              </span>
            </Col>

            <Col>
              <span className="profile-label">Gender</span>

              <span className="profile-value">
                {gender.updatedValue ? this.showLabel(gender) : null}
              </span>
            </Col>

            <Col>
              <span className="profile-label">Ethnicity and Race</span>

              <span className="profile-value">
                {ethnicity.updatedValue ? this.showLabel(ethnicity) : null}
              </span>
            </Col>

            <Col>
              <span className="profile-label">Sexual Orientation</span>

              <span className="profile-value">
                {sexualOrientation.updatedValue
                  ? this.showLabel(sexualOrientation)
                  : null}
              </span>
            </Col>

            <Col>
              <span className="profile-label">Veteran Status</span>

              <span className="profile-value">
                {veteran.updatedValue ? this.showLabel(veteran) : null}
              </span>
            </Col>

            <Col>
              <span className="profile-label">Disability</span>

              <span className="profile-value">
                {disability.updatedValue ? this.showLabel(disability) : null}
              </span>
            </Col>

            <Col>
              <span className="profile-label">Religion</span>

              <span className="profile-value">
                {religion.updatedValue ? this.showLabel(religion) : null}
              </span>
            </Col>
          </div>
        </div>
        <div className="row mt10">
          <Col>
            <If condition={!isMobile}>
              <a
                className="edit-profile-info-link flaticon-edit"
                onClick={() => {
                  this.setState((state) => ({
                    showEditProfileInfoModal: !state.showEditProfileInfoModal,
                  }));
                }}
              >
                Edit Profile Information
              </a>
            </If>
          </Col>
        </div>
        <Modal isOpen={showEditProfileInfoModal} className="profile-info-modal">
          <ModalBody className="profile-modal-body">
            <Row className="mlmr0">
              {!isMobile && (
                <span className="col-sm-6 col-md-6 profile-modal-heading-txt ">
                  Edit Profile Information
                </span>
              )}
            </Row>
            <Row className="mlmr0 mt30">
              <Col
                sm={3}
                className="profile-modal-label align-self-center"
              ></Col>
              <Col sm={9}>
                <div className="img-container">
                  {profilePic ? (
                    <img
                      src={
                        profilePic.profilePicUrl ||
                        profilePic.value ||
                        UserRobot1
                      }
                      className="user-profile-img"
                    />
                  ) : (
                    <img src={UserRobot1} className="user-profile-img" />
                  )}

                  <div className="middle">
                    <div className="text d-flex align-items-center justify-content-center">
                      <label
                        htmlFor="profile-pic-file-input"
                        style={{ marginBottom: "0px" }}
                      >
                        <span
                          className="cursor-pointer edit-txt "
                          style={{ color: "white" }}
                        >
                          edit
                        </span>
                      </label>
                      <input
                        id="profile-pic-file-input"
                        onChange={this.handleProfilePicUpload}
                        type="file"
                      />
                    </div>
                  </div>
                </div>
                {profilePic.error ? (
                  <div className="input-error-msg-field">
                    {profilePic.errorMessage}
                  </div>
                ) : null}

                <label className="changeProfilePic">
                  Change Profile Picture
                  <input
                    id="profile-pic-file-input"
                    type="file"
                    onChange={this.handleProfilePicUpload}
                  ></input>
                </label>
              </Col>
            </Row>

            <Row className="mlmr0 mt10">
              <Col sm={3} className="profile-modal-label">
                First Name
              </Col>
              <Col sm={9}>
                <Input
                  type="text"
                  className="input-custom"
                  value={firstName.updatedValue}
                  onChange={(event) => {
                    this.setState({
                      firstName: {
                        updatedValue: event.target.value,
                        value: firstName.value,
                      },
                    });
                  }}
                  invalid={firstName.error}
                />
                {firstName.error ? (
                  <div className="input-error-msg-field">
                    {firstName.errorMessage}
                  </div>
                ) : null}
              </Col>
            </Row>
            <Row className="mlmr0 mt10">
              <Col sm={3} className="profile-modal-label">
                Last Name
              </Col>
              <Col sm={9}>
                <Input
                  type="text"
                  className="input-custom"
                  value={lastName.updatedValue}
                  onChange={(event) => {
                    this.setState({
                      lastName: {
                        updatedValue: event.target.value,
                        value: lastName.value,
                      },
                    });
                  }}
                  invalid={lastName.error}
                />
                {lastName.error ? (
                  <div className="input-error-msg-field">
                    {lastName.errorMessage}
                  </div>
                ) : null}
              </Col>
            </Row>
            <Row className="mlmr0 mt10">
              <Col sm={3} className="profile-modal-label">
                Title
              </Col>
              <Col sm={9}>
                <Input
                  type="text"
                  className="input-custom"
                  value={title.updatedValue}
                  onChange={(event) => {
                    this.setState({
                      title: {
                        updatedValue: event.target.value,
                        value: title.value,
                      },
                    });
                  }}
                  invalid={title.error}
                />
                {title.error ? (
                  <div className="input-error-msg-field">
                    {title.errorMessage}
                  </div>
                ) : null}
              </Col>
            </Row>

            <Row className="mlmr0 mt10">
              <Col sm={3} className="profile-modal-label">
                <div className="text-right profile-modal-label">Occupation</div>
                <div className="profile-modal-optional-txt">(optional)</div>
              </Col>
              <Col sm={9}>
                <Select
                  className="map-table-dropdown"
                  placeholder="Select occupation"
                  value={
                    occupation.updatedValue
                      ? this.diversityValue(
                          occupation,
                          this.props.user.occupation,
                          "occupation"
                        )
                      : null
                  }
                  optionRenderer={this.renderFieldOptions}
                  clearable={false}
                  options={occupation.options.sort(function(a, b) {
                    if (a.label < b.label) return -1;
                    else if (a.label > b.label) return 1;
                    return 0;
                  })}
                  valueKey="value"
                  labelKey="label"
                  getOptionLabel={({ label }) => label}
                  getOptionValue={({ value }) => value}
                  onChange={(e) => this.updateDiversity(e, occupation)}
                />
              </Col>
            </Row>

            <Row className="mlmr0 mt10">
              <Col sm={3} className="profile-modal-label">
                <div className="text-right profile-modal-label">
                  Job Category
                </div>
                <div className="profile-modal-optional-txt">(optional)</div>
              </Col>
              <Col sm={9}>
                <Select
                  className="map-table-dropdown"
                  placeholder="Select job category"
                  value={
                    seniority.updatedValue
                      ? this.diversityValue(
                          seniority,
                          this.props.user.seniority,
                          "seniority"
                        )
                      : null
                  }
                  optionRenderer={this.renderFieldOptions}
                  clearable={false}
                  options={seniority.options.sort(function(a, b) {
                    if (a.label < b.label) return -1;
                    else if (a.label > b.label) return 1;
                    return 0;
                  })}
                  valueKey="value"
                  labelKey="label"
                  getOptionLabel={({ label }) => label}
                  getOptionValue={({ value }) => value}
                  onChange={(e) => this.updateDiversity(e, seniority)}
                />
              </Col>
            </Row>
            {/* <Row className="mlmr0 mt10">
                           <Col sm={3}>
                             <div className="text-right profile-modal-label">DEI Role</div>
                             <div className="profile-modal-optional-txt">(optional)</div> 
                           </Col>
                           <Col sm={9}>
                           <div className="inner-addon right-addon">
                             <span className="diRole-max-length-hint">{dIRole.updatedValue ? dIRole.updatedValue.length : '0'}/250</span>
                             <Input 
                                type="textarea" 
                                minLength="0"
                                maxLength="250"
                                className="profile-modal-textarea"
                                value={dIRole.updatedValue}
                                style={{resize: 'none'}}
                                onChange={(event) => {
                                    this.setState({dIRole:{ updatedValue: event.target.value, value: dIRole.value}});
                                   }}
                                />
                              </div>
                           </Col>
                        </Row> */}

            <Row className="mlmr0 mt10">
              <Col sm={3} className="profile-modal-label">
                <div className="text-right profile-modal-label">
                  Date of Birth
                </div>
                <div className="profile-modal-optional-txt">(optional)</div>
              </Col>
              <Col sm={9}>
                <div className="inner-addon right-addon">
                  {/* <span className="tool-start-date flaticon-calendar" onClick={() => this.openDatePicker("selectFileDate")} /> */}
                  <DatePicker
                    id="selectFileDate"
                    placeholderText="Enter birth date"
                    className="input-custom-date form-control"
                    showYearDropdown
                    onChange={this.handleDateChange}
                    selected={
                      birthDate.updatedValue
                        ? moment(birthDate.updatedValue)
                        : null
                    }
                    maxDate={moment()}
                  />
                </div>
              </Col>
            </Row>

            <Row className="mlmr0 mt10">
              <Col sm={3} className="profile-modal-label">
                <div className="text-right profile-modal-label">Gender</div>
                <div className="profile-modal-optional-txt">(optional)</div>
              </Col>
              <Col sm={9}>
                <Select
                  className="map-table-dropdown"
                  placeholder="Select gender"
                  // value={this.diversityValue(gender)}
                  value={
                    gender.updatedValue
                      ? this.diversityValue(
                          gender,
                          this.props.user.gender,
                          "gender"
                        )
                      : null
                  }
                  // optionRenderer={this.renderFieldOptions}
                  clearable={false}
                  options={gender.options.sort(function(a, b) {
                    if (a.label < b.label) return -1;
                    else if (a.label > b.label) return 1;
                    return 0;
                  })}
                  valueKey="value"
                  labelKey="label"
                  getOptionLabel={({ label }) => label}
                  getOptionValue={({ value }) => value}
                  onChange={(e) => this.updateDiversity(e, gender)}
                  // onChange={(event)=> this.setState({gender: { updatedValue: {value:event.target.value, label:event.target.value}}}) }
                />
              </Col>
            </Row>

            <Row className="mlmr0 mt10">
              <Col sm={3} className="profile-modal-label">
                <div className="text-right profile-modal-label">Ethnicity</div>
                <div className="profile-modal-optional-txt">(optional)</div>
              </Col>
              <Col sm={9}>
                <Select
                  className="map-table-dropdown"
                  placeholder="Select ethnicity"
                  value={
                    ethnicity.updatedValue
                      ? this.diversityValue(
                          ethnicity,
                          this.props.user.ethnicity,
                          "ethnicity"
                        )
                      : null
                  }
                  optionRenderer={this.renderFieldOptions}
                  clearable={false}
                  options={ethnicity.options.sort(function(a, b) {
                    if (a.label < b.label) return -1;
                    else if (a.label > b.label) return 1;
                    return 0;
                  })}
                  valueKey="value"
                  labelKey="label"
                  getOptionLabel={({ label }) => label}
                  getOptionValue={({ value }) => value}
                  onChange={(e) => this.updateDiversity(e, ethnicity)}
                />
              </Col>
            </Row>

            <Row className="mlmr0 mt10">
              <Col sm={3} className="profile-modal-label">
                <div className="text-right profile-modal-label">
                  Sexual Orientation
                </div>
                <div className="profile-modal-optional-txt">(optional)</div>
              </Col>
              <Col sm={9}>
                <Select
                  className="map-table-dropdown"
                  placeholder="Select sexual orientation"
                  value={
                    sexualOrientation.updatedValue
                      ? this.diversityValue(
                          sexualOrientation,
                          this.props.user.sexualOrientation,
                          "sexualOrientation"
                        )
                      : null
                  }
                  optionRenderer={this.renderFieldOptions}
                  clearable={false}
                  options={sexualOrientation.options.sort(function(a, b) {
                    if (a.label < b.label) return -1;
                    else if (a.label > b.label) return 1;
                    return 0;
                  })}
                  valueKey="value"
                  labelKey="label"
                  getOptionLabel={({ label }) => label}
                  getOptionValue={({ value }) => value}
                  onChange={(e) => this.updateDiversity(e, sexualOrientation)}
                />
              </Col>
            </Row>

            <Row className="mlmr0 mt10">
              <Col sm={3} className="profile-modal-label">
                <div className="text-right profile-modal-label">
                  Veteran Status
                </div>
                <div className="profile-modal-optional-txt">(optional)</div>
              </Col>
              <Col sm={9}>
                <Select
                  className="map-table-dropdown"
                  placeholder="Select veteran type"
                  value={
                    veteran.updatedValue
                      ? this.diversityValue(
                          veteran,
                          this.props.user.veteran,
                          "veteran"
                        )
                      : null
                  }
                  optionRenderer={this.renderFieldOptions}
                  clearable={false}
                  options={veteran.options}
                  valueKey="value"
                  labelKey="label"
                  getOptionLabel={({ label }) => label}
                  getOptionValue={({ value }) => value}
                  onChange={(e) => this.updateDiversity(e, veteran)}
                />
              </Col>
            </Row>

            <Row className="mlmr0 mt10">
              <Col sm={3} className="profile-modal-label">
                <div className="text-right profile-modal-label">Disability</div>
                <div className="profile-modal-optional-txt">(optional)</div>
              </Col>
              <Col sm={9}>
                <Select
                  className="map-table-dropdown"
                  placeholder="Select disability type"
                  value={
                    disability.updatedValue
                      ? this.diversityValue(
                          disability,
                          this.props.user.disability,
                          "disability"
                        )
                      : null
                  }
                  optionRenderer={this.renderFieldOptions}
                  clearable={false}
                  options={disability.options.sort(function(a, b) {
                    if (a.label < b.label) return -1;
                    else if (a.label > b.label) return 1;
                    return 0;
                  })}
                  valueKey="value"
                  labelKey="label"
                  getOptionLabel={({ label }) => label}
                  getOptionValue={({ value }) => value}
                  onChange={(e) => this.updateDiversity(e, disability)}
                />
              </Col>
            </Row>

            <Row className="mlmr0 mt10">
              <Col sm={3} className="profile-modal-label">
                <div className="text-right profile-modal-label">Religion</div>
                <div className="profile-modal-optional-txt">(optional)</div>
              </Col>
              <Col sm={9}>
                <Select
                  className="map-table-dropdown"
                  placeholder="Select religion"
                  value={
                    religion.updatedValue
                      ? this.diversityValue(
                          religion,
                          this.props.user.religion,
                          "religion"
                        )
                      : null
                  }
                  optionRenderer={this.renderFieldOptions}
                  clearable={false}
                  options={religion.options.sort(function(a, b) {
                    if (a.label < b.label) return -1;
                    else if (a.label > b.label) return 1;
                    return 0;
                  })}
                  valueKey="value"
                  labelKey="label"
                  getOptionLabel={({ label }) => label}
                  getOptionValue={({ value }) => value}
                  onChange={(e) => this.updateDiversity(e, religion)}
                />
              </Col>
            </Row>

            <Row className={`${isMobile && "mb30"}  mlmr0 mt30`}>
              <Col sm={{ size: 4 }} md={{ size: 4 }}>
                <Button
                  className="profile-modal-save-btn"
                  onClick={this.handleEditProfileInfo}
                >
                  <span className="profile-modal-save-btn-txt">
                    {!isMobile ? "Save" : "Continue"}
                    {!isMobile && <span className="ml10 flaticon-tick"></span>}
                  </span>
                  {isMobile && (
                    <span className="ml10">
                      <img
                        className=""
                        style={{ height: "32px" }}
                        src={rightArrowImg}
                      />
                    </span>
                  )}
                </Button>
              </Col>
              {!isMobile && (
                <Col sm={{ size: 4 }} md={{ size: 4 }}>
                  <Button
                    className="profile-modal-cancel-btn"
                    onClick={() => {
                      this.setState((state) => ({
                        showEditProfileInfoModal: !state.showEditProfileInfoModal,
                        firstName: {
                          value: state.firstName.value,
                          updatedValue: state.firstName.value,
                        },
                        lastName: {
                          value: state.lastName.value,
                          updatedValue: state.lastName.value,
                        },
                        title: {
                          value: state.title.value,
                          updatedValue: state.title.value,
                        },
                        dIRole: {
                          value: state.dIRole.value,
                          updatedValue: state.dIRole.value,
                        },
                        profilePic: {
                          value: state.profilePic.value,
                          updatedValue: state.profilePic.value,
                        },
                      }));
                    }}
                  >
                    <span className="profile-modal-cancel-btn-txt">Cancel</span>
                  </Button>
                </Col>
              )}
            </Row>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

export default Loading(ProfileInfo, axios);
